export default __webpack_public_path__ + "static/media/Group@1,5x.1bc0605c.jpg";